import { Link } from 'react-router-dom';
import { useMaps } from '../../services/hooks';
import { isAdmin } from '@grs-atlas/shared';
import { useAuthRoles } from '../../auth/AuthContext';

export function AdminMapsPage() {
  const roles = useAuthRoles();
  const { data, isLoading } = useMaps();

  if (!isAdmin(roles)) {
    return <div className="empty">Administrator role required.</div>;
  }
  if (isLoading) return <div className="empty">Loading…</div>;

  return (
    <div style={{ padding: '1.5rem', maxWidth: 900, margin: '0 auto' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '1rem',
        }}
      >
        <h1 style={{ margin: 0 }}>Admin — Maps</h1>
        <Link className="btn" to="/admin/maps/new">
          Create map type
        </Link>
      </div>
      {(data?.items ?? []).length === 0 ? (
        <div className="empty panel" style={{ padding: '2rem' }}>
          No maps yet. Create your first map type to get started.
        </div>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {(data?.items ?? []).map((m) => (
            <li key={m.mapId} className="panel" style={{ padding: '1rem', marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                <div>
                  <strong>{m.name}</strong>
                  <div style={{ color: 'var(--muted)' }}>{m.mapId}</div>
                  {m.description ? (
                    <div style={{ marginTop: 4, color: 'var(--muted)', fontSize: '0.9rem' }}>
                      {m.description}
                    </div>
                  ) : null}
                </div>
                <Link className="btn secondary" to={`/admin/maps/${m.mapId}`}>
                  Edit definition
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
